import { type Manifest, type RouterConfig, PAGE_TYPE } from '@/types/manifest.ts';

const routerConfig: RouterConfig = {
    type: PAGE_TYPE.ENTRY,
    name: 'home',
    exclusiveRoutePath: '/home',
    getComponent: () => import('../home-v2/HomeV2.vue'),
};

export const manifest: Manifest = {
    ...routerConfig,
};

declare module '@patsnap/tahiti-core' {
    export interface CommandService {
        /**
         * 去到 Home 页面
         */
        executeCommand(commandId: 'command:route:home'): void;
    }
}
